var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"finance-wrapper"},_vm._l((_setup.moduleList),function(item){return _c('div',{key:item.classifCd,staticClass:"module-wrapper",attrs:{"lazy":""}},[_c('div',{staticClass:"card-content"},[_c(_setup.ChartTable,{attrs:{"item":item}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }